import * as React from 'react';
import { Link } from 'react-router-dom';

import Typography from '@Components/Typography';

import styles from './Breadcrumb.module.scss';

export interface BreadcrumbLink {
  title: string;
  id: string;
  link?: string;
}

const Breadcrumb: React.FunctionComponent<{ navLinks: BreadcrumbLink[] }> = ({ navLinks }) => {
  return (
    <nav className={styles.breadcrumb}>
      {navLinks.map(navLink => {
        const { id, title, link } = navLink;
        const element = <Typography className={styles.elementText} tag="span" size="l" msg={title} color="gray" />;
        return (
          <div key={id} className={styles.breadcrumbItem}>
            {link ? (
              <Link to={link} aria-label={navLink.title}>
                {element}
              </Link>
            ) : (
              element
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
